import React, { useEffect, useRef } from 'react'
import { Body, Box, H4 } from '../layout'
import { assetUrl } from '../../utilities'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from "gsap/ScrollTrigger"
import { useIsMobile } from '../../hooks'
import './WhyItWorks.css'
import gsap from 'gsap'

export const WhyItWorks = () => {
  const background = useRef()
  const column = useRef()
  const container = useRef()
  const { isMobile } = useIsMobile()
  const triggerRef1 = useRef(null)
  const triggerRef2 = useRef(null)

  useGSAP(() => {
    if (isMobile) {
      triggerRef1.current?.kill()
      triggerRef1.current = null
      return
    }

    triggerRef1.current = ScrollTrigger.create({
      trigger: container.current,
      start: 'top top',
      end: 'bottom bottom',
      pin: column.current,
      scrub: true
    })

    return () => {
      triggerRef1.current?.kill()
      triggerRef1.current = null
    }
  }, [isMobile])

  useEffect(() => {
    const trigger = ScrollTrigger.create({
      trigger: container.current,
      start: "top top",
      end: "bottom bottom",
      pin: background.current,
      scrub: true
    })

    setTimeout(() => {
      ScrollTrigger.refresh()
    }, 1000)

    return () => {
      trigger.kill()
    }
  }, [isMobile])

  return (
    <Box ref={container} className="why-it-works section-padding" pb={!isMobile && 300} container>
      <Box
        className="why-background"
        ref={background}
        position="absolute"
        top={0}
        width="100dvw"
        height="100dvh"
        background={`url(${assetUrl('why-it-works-background.png')})`} style={{ backgroundSize: 'cover' }}
      />
      <Box ref={column} className="why-section why-title" alignItems="center">
        <Box justifyContent="center" fullWidth gap={16} column>
          <H4>Why it works</H4>
          <Body className="subtext" size={24}>Shivoo works because it combines four things most tools separate. When these happen together, teams don’t just gain insight - they change how they operate.</Body>
        </Box>
      </Box>
      <Box className="why-section why-outcomes"  column gap={32} justifyContent="center" alignItems="center">
        <Outcome
          image={<img src={assetUrl('people.png')} alt="people"/>}
          title="Shared Sensemaking"
          text="A clear, rigorous framework for understanding team performance"
        />
        <Outcome
          image={<img src={assetUrl('flower.png')} alt="flower"/>}
          title="Measurements & Insights"
          text="Track performance across key practices and compare over time."
        />
        <Outcome
          image={<img src={assetUrl('conversation.png')} alt="conversation"/>}
          title="Conversation Starter"
          text="The conversations your team needs to have - happening in real time."
        />
        <Outcome
          image={<img src={assetUrl('meter.png')} alt="meter"/>}
          title="A Development Partner"
          text="Know what to work on next - and see your progress"
        />
      </Box>
    </Box>
  )
}

const Outcome = ({ image, title, text }) => {
  const ref = useRef()

  useGSAP(() => {
    gsap.fromTo(
      ref.current,
      {
        opacity: 0,
        scale: 1.05
      },
      {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: ref.current,
          start: 'center bottom',
          end: 'center center',
          scrub: true,
        }
      },
    )
  }, { scope: ref })

  return (
    <Box ref={ref} justifyContent="center" gap={8} column height="50dvh">
      <Box alignItems="center" justifyContent="center">
        {image}
      </Box>
      <Body size={32} weight={600} align="center">{title}</Body>
      <Body className="outcome-subtext" align="center" size={16}>{text}</Body>
    </Box>
  )
}